import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const ModalCreateTaskByHrResponseAsync = lazyWithRetry(
  () => import('./modal-create-task-searchByHrResponse'),
)
